/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popWithdraw.vue?vue&type=template&id=b0b4ab16&scoped=true"
import script from "./popWithdraw.vue?vue&type=script&lang=js"
export * from "./popWithdraw.vue?vue&type=script&lang=js"
import style0 from "./popWithdraw.vue?vue&type=style&index=0&id=b0b4ab16&prod&lang=scss&scoped=true"
import style1 from "./popWithdraw.vue?vue&type=style&index=1&id=b0b4ab16&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b4ab16",
  null
  
)

export default component.exports